import { AnyAction } from 'redux'
import requestStatuses from '@cinch/oxd-utils/request-status/src'
import {
  REQUEST_FINANCE_QUOTES,
  RECEIVE_FINANCE_QUOTES,
  ERROR_FINANCE_QUOTES,
  RECEIVE_FINANCE_DECISION,
  REQUEST_INDICATIVE_APR,
  RECEIVE_INDICATIVE_APR,
  ERROR_INDICATIVE_APR,
  REQUEST_DEPOSIT_RANGE,
  RECEIVE_DEPOSIT_RANGE,
  ERROR_DEPOSIT_RANGE,
} from './constants'

export interface InitialState {
  PCPQuotes: Array<any>
  HPQuotes: Array<any>
  financeId: string
  quoteRequestState: string
  decisionStatus: string
  indicativeApr: string
  indicativeAprStatus: string
  depositRange: {
    min: number
    max: number
  }
  depositRangeRequestStatus: string
}

export const initialState: InitialState = {
  PCPQuotes: [],
  HPQuotes: [],
  financeId: '',
  quoteRequestState: requestStatuses.INITIAL,
  decisionStatus: requestStatuses.INITIAL,
  indicativeApr: '',
  indicativeAprStatus: requestStatuses.INITIAL,
  depositRange: {
    min: 0,
    max: 0,
  },
  depositRangeRequestStatus: requestStatuses.INITIAL,
}

const financeReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FINANCE_QUOTES:
      return {
        ...state,
        quoteRequestState: requestStatuses.PENDING,
      }
    case RECEIVE_FINANCE_QUOTES:
      return {
        ...state,
        ...action.payload,
        quoteRequestState: requestStatuses.SUCCESS,
      }
    case ERROR_FINANCE_QUOTES:
      return {
        ...state,
        quoteRequestState: requestStatuses.ERROR,
      }
    case REQUEST_INDICATIVE_APR:
      return {
        ...state,
        indicativeAprStatus: requestStatuses.PENDING,
      }
    case RECEIVE_INDICATIVE_APR:
      return {
        ...state,
        indicativeApr: action.payload.apr,
        indicativeAprStatus: requestStatuses.SUCCESS,
      }
    case ERROR_INDICATIVE_APR:
      return {
        ...state,
        indicativeAprStatus: requestStatuses.ERROR,
      }
    case RECEIVE_FINANCE_DECISION:
      return {
        ...state,
        decisionStatus: action.payload,
      }

    case REQUEST_DEPOSIT_RANGE:
      return {
        ...state,
        depositRangeRequestStatus: requestStatuses.PENDING,
      }
    case RECEIVE_DEPOSIT_RANGE:
      return {
        ...state,
        depositRange: {
          min: action.payload.minDeposit,
          max: action.payload.maxDeposit,
        },
        depositRangeRequestStatus: requestStatuses.SUCCESS,
      }
    case ERROR_DEPOSIT_RANGE:
      return {
        ...state,
        depositRangeRequestStatus: requestStatuses.ERROR,
      }
    default:
      return state
  }
}

export default financeReducer
